import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addWorkstationBookingDetails: { loading: false, data: null, error: null },
  WorkstationBookingList: { loading: false, data: null, error: null },
};

export const Workstation = createSlice({
  name: "workstation",
  initialState,
  reducers: {
    fetchWorkstationBookingListRequest: (state, action) => {
      state.WorkstationBookingList.loading = true;
      state.WorkstationBookingList.error = null;
    },
    fetchWorkstationBookingListSuccess: (state, action) => {
      state.WorkstationBookingList.data = action.payload;
      state.WorkstationBookingList.loading = false;
      state.WorkstationBookingList.error = null;
    },
    fetchWorkstationBookingListFaliure: (state, action) => {
      state.WorkstationBookingList.data = null;
      state.WorkstationBookingList.loading = false;
      state.WorkstationBookingList.error = action.payload;
    },

    addWorkstationBookingRequest: (state, action) => {
      state.addWorkstationBookingDetails.loading = true;
      state.addWorkstationBookingDetails.error = null;
    },
    addWorkstationBookingSuccess: (state, action) => {
      state.addWorkstationBookingDetails.data = action.payload;
      state.addWorkstationBookingDetails.loading = false;
      state.addWorkstationBookingDetails.error = null;
      state.WorkstationBookingList = addWorkstationBookingDetailsSuccess(
        action.payload,
        {
          ...state.WorkstationBookingList,
        }
      );
    },
    addWorkstationBookingFailure: (state, action) => {
      state.addWorkstationBookingDetails.data = null;
      state.addWorkstationBookingDetails.loading = false;
      state.addWorkstationBookingDetails.error = action.payload;
    },
  },
});

function addWorkstationBookingDetailsSuccess(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}

export const {
  fetchWorkstationBookingListRequest,
  fetchWorkstationBookingListSuccess,
  fetchWorkstationBookingListFailure,
  addWorkstationBookingRequest,
  addWorkstationBookingSuccess,
  addWorkstationBookingFailure,
} = Workstation.actions;

export const getWorkstationBookingListState = (store) =>
  store.workstation?.WorkstationBookingList;
export const getWorkstationBookingCreateState = (store) =>
  store.workstation?.addWorkstationBookingDetails;

export default Workstation.reducer;
